class VwUcrettarifeDTO {
  id?: number = null;
  fkHbsUcretTarifetanimId?: number = null;
  fkHbsIslemtanimId?: number = null;
  islemtanimAd?: string = "";
  baslangictarih?: string = null;
  bitistarih?: string = null;
  ucret?: number = 0;
  aktif?: string = "E";
  ekleyenKullanici?: number = null;
  eklemeTarihi?: string = null;
  guncelleyenKullanici?: number = null;
  guncellemeTarihi?: string = null;
  paketdahil?: string = "H";
  aktifBool?: boolean = true;
  paketDahilBool?: boolean = false;
  parabirimId?: number = null;
  hesaplamaformulId?: number = null;
  kdvdahil?: string = "H";
  islempuan?: number = null;
}
export default VwUcrettarifeDTO;